import BackendService from 'BackendService';
import {
  CreateInvestmentEntityRequest,
  InvestmentAllocation,
  InvestmentEntity,
} from '../../../models/InvestmentEntity';
import Investor from '../../../models/Investor';

export async function createAndAssociateEntity(
  investorId: string,
  entityData: CreateInvestmentEntityRequest,
): Promise<InvestmentEntity> {
  const backend = new BackendService();
  return backend.createAndAssociateInvestmentEntity(investorId, entityData);
}

export async function saveEntityAllocation(
  investor: Investor,
  entity: InvestmentEntity,
  allocatedAmount: number,
  currentAllocations: InvestmentAllocation[] = [],
): Promise<boolean> {
  const backend = new BackendService();
  const existingAllocation = currentAllocations.find((a) => a.investmentEntityId === entity.id);

  if (existingAllocation) {
    const updated = currentAllocations.map((a) =>
      a.investmentEntityId === entity.id ? { ...a, allocatedAmount } : a,
    );

    await backend.updateInvestorAllocations(
      investor.id,
      updated.map((a) => ({
        investmentEntityId: a.investmentEntityId,
        amount: Number(a.allocatedAmount),
      })),
    );
    return true;
  }

  await backend.associateInvestorWithEntityAndAmount(investor.id, entity.id, allocatedAmount);
  return false;
}

export const ASSOCIATION_TIMEOUT_MS = 30000;
export const MESSAGE_DISMISS_MS = 5000;
